/** 权签需求 => 所属公司单独接口
 * 所属公司过滤单选
 *    默认选择全部
 *    接收onChange事件 以数组的格式返回所选公司的全部数据
 */

import React, { useState, useEffect, useRef } from 'react'
import { Tag, Icon } from 'antd'
import api from '@/api'
import { useDispatch } from 'react-redux'
import { setCompanyList } from '@/global/reducer/companyList'

const { CheckableTag } = Tag

const CorpQuanQian = props => {
  const { supra = true, defaultValue, part = '' } = props;
  const [list, setList] = useState([])
  const [checkedAll, setCheckedAll] = useState(defaultValue ? false : true)
  const [showAll, setShowAll] = useState(false)
  const [showAllBtn, setShowAllBtn] = useState(false)

  const listRef = useRef(null)
  const dispatch = useDispatch()

  useEffect(() => {
    api.getHeadCompanyList({ limit: global.paramsLimit, type: part ? part : '' }).then(data => {
      const list = data.map(item => ({ ...item, checked: isChecked(item.id, defaultValue)}))
      setList(list)
      dispatch(setCompanyList(list))
    })
  }, [])

  useEffect(() => {
    if (listRef.current.scrollHeight > 25) {
      setShowAllBtn(true)
    }
  })

  useEffect(() => {
    window.addEventListener('resize', onSetShowAllBtn, false)
    return () => {
      window.removeEventListener('resize', onSetShowAllBtn, false)
    }
  })

  const isChecked = (value, values) => {
    if (Array.isArray(values)) {
      return values.indexOf(value) > -1;
    }
    return value === values;
  };

  const onSetShowAllBtn = () => {
    if (listRef.current.scrollHeight > 25) {
      setShowAllBtn(true)
    } else {
      setShowAllBtn(false)
    }
  }

  const onChange = (checked, id) => {
    // 单选[]
    const items = list.map(item => {
      if (item.id === id) {
        return { ...item, checked }
      }
      return { ...item, checked: false }
    })

    const checkedList = items.filter(item => item.checked)
    setList(items)
    if (checkedList.length === 0) {
      setCheckedAll(true)
    } else {
      setCheckedAll(false)
    }
    props.onChange(checkedList)
  }

  const onChangeAll = checked => {
    if (checked) {
      setList(list.map(item => ({ ...item, checked: false })))
      setCheckedAll(true)
      props.onChange([])
    }
  }

  return (
    <div className="corp-filter-wrap">
      <label htmlFor="">所属公司：</label>
      <div className={`corp-filter-list${showAll?' show-all':''}`} ref={listRef}>
        {supra && <CheckableTag checked={checkedAll} onChange={checked => onChangeAll(checked)}>全部</CheckableTag>}
        {list.map(d => <CheckableTag key={d.id} checked={d.checked} onChange={checked => onChange(checked, d.id)}>{d.name}</CheckableTag>)}
        {!supra && <CheckableTag checked={checkedAll} onChange={checked => onChangeAll(checked)}>全部</CheckableTag>}
      </div>
      {showAllBtn ? <div className="corp-filter-control-wrap">
        {showAll
          ? <span className="corp-filter-control" onClick={() => setShowAll(false)}>收起<Icon type="up" /></span>
          : <span className="corp-filter-control" onClick={() => setShowAll(true)}>展开<Icon type="down" /></span>
        }
      </div> : null}
    </div>
  )
}

export default CorpQuanQian